import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from '../layout/SVGImage';

interface PowerOutageScheduleResetButtonProps {
  testId?: string;
  className?: string;
  onClick?: () => void;
}

export const PowerOutageScheduleResetButton: React.FC<
  PowerOutageScheduleResetButtonProps
> = ({ testId, className, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={`noto-14-medium flex h-[46px] w-[112px] cursor-pointer items-center justify-between rounded-[57px] bg-light-3 px-5 text-dark-10 ${className}`}
      onClick={onClick}
    >
      <SVGImage name="loop" width={20} height={20} />
      {t('overview.modal.limit.button', { context: 'reset' })}
    </div>
  );
};
